import React, { Fragment, useState } from 'react';
import {
    Confirm
} from 'react-admin';
import Button  from "@material-ui/core/Button";

const ConfirmationButton = ({ doAction, title, content, label }) => {
    const [open, setOpen] = useState(false);
    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);

    const handleConfirm = () => {
        doAction();
        setOpen(false);
    };

    return (
        <Fragment>
            <Button variant="outlined" onClick={handleClick}>{label}</Button>
            <Confirm
                isOpen={open}
                title={title}
                content={content}
                confirm="Da"
                confirmColor="primary"
                cancel="Nu"
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />
        </Fragment>
    );
}

export default ConfirmationButton;